import React from 'react';

interface RepayButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'solid' | 'outline';
  icon?: React.ReactNode;
  className?: string;
}

const RepayButton: React.FC<RepayButtonProps> = ({ children, onClick, variant = 'solid', icon, className = '' }) => {
  const variantClassName =
    variant === 'solid'
      ? 'linear-background-color-primary text-white border-transparent'
      : 'bg-white text-[#269c6e] border-[#269c6e]';

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center justify-center gap-[8px] w-full h-[48px] rounded-[16px] border-[1.5px] border-solid font-poppins font-medium text-[14px] cursor-pointer transition-opacity duration-300 hover:opacity-90 ${variantClassName} ${className}`}
    >
      {icon}
      {children}
    </button>
  );
};

export default RepayButton;
